<template>
  <div>
    <div id="term-wrapper">
      <h2>台灣錄得清科技優惠道路救援服務條款</h2>
      <h3>行車錄得清，旅途最安心！</h3>
      <h3>全國首創！買錄得清(Loo.King)行車記錄器，贈送道路救援服務！</h3>

      <p>
        <h4>第一條  購買錄得清以下系列行車記錄器，贈送一年一次道路救援服務：</h4>
        <br/>一、LD-4s
        <br/>二、LD-4Plus
        <br/>三、LD-5Plus+
        <br/>四、LD-6s
        <br/>五、LD-7+
        <br/>六、眼界S
        <br/>七、Sport-168(汽車用前後高清雙錄)
        <br/>八、LD-8
        <br/>九、T-200
      </p>
      <p>
        <h4>第二條  資格登錄：</h4>
        <br/>
        消費者購買上述系列產品(或搭配優惠活動之產品)後7日內，並且於道路救援服務發生前，需至錄得清官網完成會員註冊、產品及車號登錄，服務始生效，逾期恕不列算有效登錄，無法提供本優惠服務。
      </p>
      <p>
        <h4>第三條  服務起算：</h4>
        <br/>
        消費者上網完成會員註冊及產品登入後，自登錄之購買日期起算1年，例如：A君於107年1月2日購買錄得清品牌LD-7+行車記錄器，並依內附道路救援卡於1月4日上網完成資料登錄，則優惠服務有效期將為1070102日起至1080102日2400時止。
      </p>
      <p>
        <h4>第四條  服務次數：</h4>
        <br/>
        一年內限提供一次優惠服務。
      </p>
      <p>
        <h4>第五條</h4>  <br/>為避免服務遭惡意使用，本服務採專卡專車制，消費者依錄得清產品內附的道路救援卡號綁定車號，將車號資料提供錄得清建立管制資料庫，有效期限內，請勿變更車籍資料，車籍資料變更則本服務無效。
      </p>
      <p>
        <h4>第六條  優惠範圍：</h4>
        <br/>
        基本價格10 公里內 1200 。
        <br/>
        一、全國通出車基本費(基本價格)為10公里內1200元，其後依地點時間及路況有所不同，消費者可先向全國通詢價議價。
        <br/>
        二、錄得清優惠範圍為『基本價格』部分，額外超出範圍為消費者自付額。
      </p>
      <p>
      第七條  服務發生前：
      <br/>
      一、申告服務：消費者在向全國通提出服務申請前，須於錄得清Line@道路救援服務專網告知以下資訊：
      <br/>
      (一)姓名
      <br/>
      (二)車號
      <br/>
      (三)聯絡手機
      <br/>
      二、完成申告後由消費者自行向全國通汽車拖吊有限公司提出服務申請，全國通汽車拖吊服務電話專線02-2517-7027 服務專網：<a href="https://carbus.com.tw/looking">https://carbus.com.tw/looking</a>。
      <br/>
      三、服務期間全國通與消費者應彼此要求並注重服務品質，錄得清僅為服務轉介角色，如有任何糾紛或損失，由全國通與消費者自行處理，概與錄得清無關。
      </p>
      <p>
      第八條  服務發生後：
      <br/>
      消費者於錄得清Line@道路救援服務專網回傳以下資料申請優惠退費，經錄得清審核無誤後匯款至消費者指定帳戶：
      <br/>
      一、發票/收據(需註記被拖吊車號)
      <br/>
      二、消費者退款銀行帳號及戶名
      </p>
      <p>
      第九條  特別注意事項：
      <br/>
      一、申請道路救援服務前，需先在道路救援專線Line@完成申告(回傳姓名、車號及聯絡電話)，否則錄得清無法查證，不予承認優惠退費。
      <br/>
      二、消費者需先向全國通汽車拖吊有限公司結清服務款項，再憑收據(需註記被拖吊車號)向錄得清申請基本費優惠退費，優惠範圍為基本費1200元，超出部分為消費者自付，不予退費。
      </p>
      <p>
      第十條  未盡事宜另行補充之。
      </p>
    </div>
    <div id="price-form-wrapper">
      <h2>價格表</h2>
      <p>* 此報價僅提供參考，實際價格可能因優惠、作業難度、作業地點而有所差異。</p> 
      <h3>一般道路</h3>
      <table>
        <tr>
          <th colspan="2">項目</th>
          <th>服務費用</th>
          <th>說明與備註</th>
        </tr>
        <tr>
          <td rowspan="3">平面拖吊</td>
          <td>一般平面</td>
          <td>1200元/10公里</td>
          <td rowspan="3">依10公里(由拋錨地點起算)內之收費方式。</td>
        </tr>
        <tr>
          <td>國道/高架</td>
          <td>1500元/公里</td>
        </tr>
        <tr>
          <td>郊區/山區</td>
          <td>2500元/公里</td>
        </tr>
        <tr>
          <td colspan="2">里程費</td>
          <td>50元/公里</td>
          <td>超過10公里，每公里加收之費用。</td>
        </tr>
        <tr>
          <td colspan="2">全載費</td>
          <td>500元/次</td>
          <td>輪胎破損、後輪傳動、四輪傳動之車輛或長程拖運之情況，提供整車承載或加裝輔助輪拖行之方式，皆謂全載作業。</td>
        </tr>
      </table>
      <h3>急修服務</h3>
      <table>
        <tr>
          <th colspan="2">項目</th>
          <th>服務費用</th>
          <th>說明與備註</th>
        </tr>
        <tr>
          <td colspan="2">接電啟動</td>
          <td>800元</td>
          <td>接電後仍無法行駛，而需拖吊時，依照拖吊標準。 ※急修接電採攜帶式電霸接電，3.5 噸貨車、柴油引擎車輛不易接電成功。</td>
        </tr>
        <tr>
          <td colspan="2">更換備胎</td>
          <td>1000元</td>
          <td>備胎及換胎工具須由您自備，若車胎因改裝或螺絲過緊無法以人工拆卸者，概以拖吊至維修廠處理。</td>
        </tr>
        <tr>
          <td colspan="2">送油送水</td>
          <td>800元</td>
          <td>油資依加油站發票向您收費，加水後仍無法行駛而需拖吊時，依照拖吊標準。</td>
        </tr>
      </table>
      <h3>特殊作業處理</h3>
      <table>
        <tr>
          <th colspan="2">項目</th>
          <th>服務費用</th>
          <th>說明與備註</th>
        </tr>
        <tr>
          <td rowspan="2">低底盤作業</td>
          <td>低於15cm</td>
          <td>1500元/次</td>
          <td>距地高11~15公分，需要額外工具輔助，需較長作業時間。</td>
        </tr>
        <tr>
          <td>低於10cm</td>
          <td>2000元/次</td>
          <td>距地高低於10公分，需要使用特殊車輛</td>
        </tr>
        <tr>
          <td rowspan="2">輪鞋上全載車</td>
          <td>兩輪鎖死</td>
          <td>1800元/次</td>
          <td rowspan="2">無法排檔或手剎車無法釋放，造成輪胎咬死需要特殊處理。</td>
        </tr>
        <tr>
          <td>四輪鎖死</td>
          <td>3000元/次</td>
        </tr>
        <tr>
          <td colspan="2" rowspan="2">地下室/立體停車場費用</td>
          <td>1500元/次</td>
          <td rowspan="2">車輛故障於地下室或樓層停車場高度限制低於，處理費B1/1F 1500元、B2/2F 2000元、B3/3F收費2500元，上限收費4000元</td>
        </tr>
        <tr>
          <td>500元/層</td>
        </tr>
        <tr>
          <td colspan="2">特殊作業</td>
          <td>議價</td>
          <td>例如車輛打滑、陷入沙地泥沼、陷於凹處、驅動輪卡死、作業 空間不足、底盤過低需墊枕木、車輛加裝尾門、架於安全島或 凸起物、事故輪胎卡死，或四輪/後輪咬死，變速箱卡 P 檔， 方向盤鎖死，翻出車道或全翻…等，包含但不限於上述情況)。</td>
        </tr>
      </table>
      <h3>加碼費</h3>
      <table>
        <tr>
          <th colspan="2">項目</th>
          <th>服務費用</th>
          <th>說明與備註</th>
        </tr>
        <tr>
          <td colspan="2">空趟</td>
          <td>500元</td>
          <td>說明車輛狀況不實，造車救援車輛無法服務，需要二次出車，於第二次出車時須付清前次空趟費用，拒絕 支付者將不予出車服務。</td>
        </tr>
        <tr>
          <td colspan="2">假日/夜間</td>
          <td>500元</td>
          <td>夜間時段係指：週一至週五晚上六點起算至翌日早上八點、國定假日及週休二日(星期六、星期日)全天至翌日早上八點。
        </td>
        </tr>
        <tr>
          <td colspan="2">偏遠郊區、特殊 地區加成費</td>
          <td>400元/20 公里 超過 20 公里每公里加收 25 元</td>
          <td>山區或偏遠地區，如中.南橫公路.蘇花公路.梨山等地，遠程出車超出 20 公里以上，每公里加收 25 元，但得車輛駕駛人同意後始行動救援。特殊山區，例如尖石鄉、泰安鄉、阿里山、霧台鄉、信義鄉、 古坑鄉、仁愛鄉、國家公園…線上另行報價計費。</td>
        </tr>
        <tr>
          <td colspan="2">待命費</td>
          <td>300元/小時</td>
          <td>凡需待警方製作筆錄或無法立即服務者，自司機到達現場後起算，每小時加收 300 元；若等待超過 30 分鐘時，以一小時計收。</td>
        </tr>
        <tr>
          <td colspan="2">遠郊近拖</td>
          <td>正常收費/2</td>
          <td>偏遠地區，拖行短距離，公里數計算方式為：拖車出發點至完成救援服務再返回出發點的全程里程數。</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Price',
  data () {
    return {
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h4 {
  margin: 0;
}
#term-wrapper {
  text-align: left;
  padding: 30px 8px;
}
#price-form-wrapper {
  padding: 30px 8px;
  text-align: center;
}
#price-form-wrapper h3 {
  text-align: left;
}
#price-form-wrapper table {
  width: 100%;
  border: 1px solid rgba(0,0,0, 0.3);
}
#price-form-wrapper table th {
  background-color: rgba(0,0,0, 0.3);
  padding: 10px;
}
#price-form-wrapper table th:nth-child(1) {
  width: 350px;
}
#price-form-wrapper table th:nth-child(2) {
  width: 100px;
}
#price-form-wrapper table td {
  padding: 10px;
  border: 1px solid rgba(0,0,0, 0.3);
}

</style>



// WEBPACK FOOTER //
// src/components/Price.vue